export default function () {
	let navbarCollapse = document.getElementById('navbarContent');
	let navbarSearchCollapse = document.getElementById('navbarSearchContent');

	// Focus do search políčko po rozbalení collapse navbaru
	// Zároveň zavře mobilní menu, pokud je otevřené
	navbarSearchCollapse.addEventListener('shown.bs.collapse', (event) => {
		const searchInput = navbarSearchCollapse.querySelector('.header-search');
		if (searchInput) {
			let navbarCollapseInstance = window.Collapse.getInstance(navbarCollapse);
			if (navbarCollapseInstance) {
				navbarCollapseInstance.hide();
			}
			searchInput.focus();
		}
	});

	//Vyprázní pole pro hledání a schová search box
	const closeSearchInputButton = document.querySelector('.close-search-input');
	closeSearchInputButton.addEventListener('click', (event) => {
		event.preventDefault();
		navbarSearchCollapse.querySelector('.header-search').value = '';
		let navbarSearchCollapseInstance = window.Collapse.getInstance(navbarSearchCollapse);
		if (navbarSearchCollapseInstance) {
			navbarSearchCollapseInstance.hide();
		}
	});

	// Zavře vyhledávací pole, pokud je otevřené
	navbarCollapse.addEventListener('shown.bs.collapse', (event) => {
		let navbarSearchCollapseInstance = window.Collapse.getInstance(navbarSearchCollapse);
		if (navbarSearchCollapseInstance) {
			navbarSearchCollapseInstance.hide();
		}
	});
}
